{
  "name": "vizorro",
  "author": {
    "name": "Open Systems Ltd."
  },
  "description": "Project management and text, video, audio chat complex solution",
  "version": "3.9.22",
  "scripts": {
    "ng": "ng",
    "serve": "ng s web",
    "s:prod": "ng s web --configuration=prod",
    "s:dev": "ng s web --host applocal.dev.vizorro.ru --port 8443 --ssl --ssl-cert applocal-cert.crt --ssl-key applocal-cert.key --proxy-config proxy-dev.conf.json",
    "test": "ng test web --watch=false",
    "anal": "esbuild-visualizer --metadata dist/web/stats.json --open",
    "circus": "dpdm --warning false src/main.ts",
    "get-version": "echo $npm_package_version",
    "local": "ng s web --proxy-config proxy.conf.json --watch=false",
    "local:admin": "ng s admin --proxy-config proxy.conf.json --watch=false",
    "build": "npm run build:prod",
    "build:prodev": "ng b web --configuration=build,prodev --stats-json",
    "build:prod": "ng b web --configuration=build,prod --stats-json",
    "build:prod-debug": "ng b web --configuration=debugBuild,prod --stats-json",
    "build:dev": "ng b web --configuration=build,dev --stats-json",
    "build:cef": "npm run build:cef:prod",
    "build:cef:prod": "ng b web --configuration=build,cef_prod",
    "build:cef:dev": "ng b web --configuration=build,cef_dev",
    "build:ent": "npm run build:ent:prod",
    "build:ent:prod": "ng b web --configuration=build,ent_prod --stats-json",
    "build:ent:dev": "ng b web --configuration=build,ent_dev --stats-json",
    "admin:build": "npm run admin:build:prod",
    "admin:build:prodev": "ng b admin --configuration=build,prodev --stats-json",
    "admin:build:prod": "ng b admin --configuration=build,prod --stats-json",
    "admin:build:dev": "ng b admin --configuration=build,dev --stats-json",
    "upgrader:build": "npm run upgrader:build:prod",
    "upgrader:build:prodev": "ng b upgrader --configuration=build,prodev",
    "upgrader:build:prod": "ng b upgrader --configuration=build,prod --source-map false",
    "upgrader:build:dev": "ng b upgrader --configuration=build,dev",
    "upgrader:tar": "npm run upgrader:build && cd dist/upgrader && tar -cf www.tar www && dir=`pwd` && cd / && ls -l $dir/www.tar",
    "wiki:build": "npm run wiki:build:prod",
    "wiki:build:prodev": "ng b wiki --configuration=build,prodev --stats-json",
    "wiki:build:prod": "ng b wiki --configuration=build,prod --stats-json",
    "wiki:build:dev": "ng b wiki --configuration=build,dev --stats-json",
    "wiki:anal": "esbuild-visualizer --metadata dist/wiki/stats.json --open",
    "btn:start": "npm run btn:bl && npm run btn:s",
    "ls:web": "live-server --no-browser dist/web",
    "ls:admin": "live-server --no-browser dist/admin",
    "ls:btn": "live-server --no-browser dist/button",
    "btn:bl": "npm run btn:build:local && cp button/test.html dist/button/index.html",
    "btn:build:themes": "for file in button/src/themes/*.less; do npx less -x -s $file dist/button/`basename -s .less $file`.css ; done",
    "btn:build": "npm run btn:build:prod",
    "btn:build:prod": "ng b button --configuration=build,prod && node button/elements-build.js && npm run btn:build:themes",
    "btn:build:dev": "ng b button --configuration=build,dev && node button/elements-build.js && npm run btn:build:themes",
    "btn:build:local": "ng b button --configuration=build,local && npm run btn:build:themes",
    "btn:anal": "esbuild-visualizer --metadata dist/button/stats.json --open",
    "docs:api": "node generate-apidocs.mjs",
    "docs:api:md": "node generate-apidocs-md.mjs",
    "deps": "dpdm --warning=false ./src/main.ts",
    "bur": "browserslist-useragent-regexp --allowHigherVersions",
    "tauri": "tauri"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/elements": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@angular/service-worker": "^22.1.6",
    "@cantoo/pdf-lib": "^1.21.1",
    "@capacitor-community/safe-area": "^8.0.1",
    "@capacitor-firebase/messaging": "^8.5.1",
    "@capacitor/android": "^8.5.2",
    "@capacitor/app": "^8.1.1",
    "@capacitor/core": "^8.5.2",
    "@capacitor/filesystem": "^8.1.3",
    "@capacitor/haptics": "^8.0.2",
    "@capacitor/local-notifications": "^8.3.1",
    "@capacitor/status-bar": "^8.0.3",
    "@capawesome/capacitor-badge": "^8.0.3",
    "@capgo/capacitor-native-biometric": "8.6",
    "@capgo/native-audio": "8.4.2",
    "@ctrl/tinycolor": "^4.2.1",
    "@dimanoid/ngx-dm-divider": "0.0.13",
    "@dimanoid/stomp": "0.1.5",
    "@jsplumb/browser-ui": "^6.2.10",
    "@opensys/vizorro": "file:capacitor_plugins/vizorro",
    "@pdf-lib/fontkit": "^1.1.1",
    "@tiptap/core": "3.31.3",
    "@tiptap/extension-highlight": "3.31.3",
    "@tiptap/extension-link": "3.31.3",
    "@tiptap/extension-mention": "3.31.3",
    "@tiptap/extension-placeholder": "3.31.3",
    "@tiptap/extension-subscript": "3.31.3",
    "@tiptap/extension-superscript": "3.31.3",
    "@tiptap/extension-table": "3.31.3",
    "@tiptap/extension-table-of-contents": "3.31.3",
    "@tiptap/extension-task-item": "3.31.3",
    "@tiptap/extension-task-list": "3.31.3",
    "@tiptap/extension-text-align": "3.31.3",
    "@tiptap/extension-text-style": "3.31.3",
    "@tiptap/extension-underline": "3.31.3",
    "@tiptap/extension-unique-id": "3.31.3",
    "@tiptap/starter-kit": "3.31.3",
    "@vitest/coverage-istanbul": "^4.1.1",
    "@vitest/coverage-v8": "^4.1.1",
    "capacitor-blob-writer": "^1.1.20",
    "character-entities": "^2.0.2",
    "core-js": "^3.50.0",
    "d3": "^7.9.0",
    "date-fns": "^4.4.0",
    "diff-match-patch-typescript": "^1.1.3",
    "emojibase": "6.1.0",
    "emojibase-data": "7.0.1",
    "emojibase-regex": "6.0.1",
    "firebase": "^12.19.0",
    "idb": "^8.0.3",
    "immer": "^11.1.18",
    "jwt-decode": "^4.0.0",
    "ng-zorro-antd": "22.0.1",
    "ngx-clipboard": "^16.0.0",
    "ngx-extended-pdf-viewer": "^30.0.1",
    "opfsdb": "^1.0.8",
    "rxjs": "~7.8.2",
    "tauri": "^0.15.0",
    "tippy.js": "^6.3.7",
    "tslib": "^2.8.1",
    "typescript": "^6",
    "vitest": "^4.1.1",
    "webrtc-adapter": "^9.0.6"
  },
  "resolutions": {
    "@tiptap/core": "3.27.1",
    "@tiptap/pm": "3.27.1",
    "@tiptap/starter-kit": "3.27.1"
  },
  "overrides": {
    "@tiptap/core": "3.31.3",
    "@tiptap/extension-highlight": "3.31.3",
    "@tiptap/extension-mention": "3.31.3",
    "@tiptap/extension-placeholder": "3.31.3",
    "@tiptap/extension-subscript": "3.31.3",
    "@tiptap/extension-superscript": "3.31.3",
    "@tiptap/extension-table": "3.31.3",
    "@tiptap/extension-table-of-contents": "3.31.3",
    "@tiptap/extension-task-item": "3.31.3",
    "@tiptap/extension-task-list": "3.31.3",
    "@tiptap/extension-text-align": "3.31.3",
    "@tiptap/extension-text-style": "3.31.3",
    "@tiptap/extension-unique-id": "3.31.3",
    "@tiptap/extension-blockquote": "3.27.1",
    "@tiptap/extension-bold": "3.27.1",
    "@tiptap/extension-bullet-list": "3.27.1",
    "@tiptap/extension-code": "3.27.1",
    "@tiptap/extension-document": "3.27.1",
    "@tiptap/extension-dropcursor": "3.27.1",
    "@tiptap/extension-gapcursor": "3.27.1",
    "@tiptap/extension-hard-break": "3.27.1",
    "@tiptap/extension-heading": "3.27.1",
    "@tiptap/extension-horizontal-rule": "3.27.1",
    "@tiptap/extension-italic": "3.27.1",
    "@tiptap/extension-list": "3.27.1",
    "@tiptap/extension-list-item": "3.27.1",
    "@tiptap/extension-list-keymap": "3.27.1",
    "@tiptap/extension-ordered-list": "3.27.1",
    "@tiptap/extension-paragraph": "3.27.1",
    "@tiptap/extension-strike": "3.27.1",
    "@tiptap/extension-text": "3.27.1",
    "@tiptap/extensions": "3.27.1",
    "@tiptap/pm": "3.27.1"
  },
  "devDependencies": {
    "@angular/build": "^22.1.8",
    "@angular/cli": "^22.1.8",
    "@angular/compiler-cli": "^22.1.6",
    "@angular/localize": "^22.1.6",
    "@capacitor/cli": "^8.5.2",
    "@tauri-apps/cli": "^2.11.4",
    "@types/d3": "^7.4.3",
    "@types/node": "^26.5.1",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "browserslist-useragent-regexp": "^4.1.4",
    "concat": "^1.0.3",
    "dpdm": "^4.3.0",
    "esbuild-visualizer": "^0.7.0",
    "jsdom": "^30.0.1",
    "less": "^4.9.1",
    "live-server": "^1.2.2",
    "prettier": "^3.9.6",
    "ts-morph": "^28.0.0",
    "ts-node": "~10.9.2",
    "tzdata": "^1.0.51"
  },
  "scarfSettings": {
    "enabled": false
  },
  "sideEffects": false
}
